import { queryOptions } from "@tanstack/react-query";

import { getCoachCallsAndLinksFn } from "~/lib/functions/calls-and-links";

export const callsAndLinksKeys = {
  coach: ["calls-and-links"] as const,
};

/** The live calls and the Book-a-call link, as an admin last saved them. */
export function callsAndLinksQueryOptions() {
  return queryOptions({
    queryKey: callsAndLinksKeys.coach,
    queryFn: () => getCoachCallsAndLinksFn(),
    // An admin changes these rarely; a full page load always reads them fresh.
    staleTime: 5 * 60 * 1000,
  });
}
